import { Unionize } from 'utilitys/helpers/TsGeneral';
import { StateCreator, create } from 'zustand';
import { persist } from 'zustand/middleware';

import { IGetUserDetailResponse } from 'api/queries/getUserDetail.query';

interface Props {
    user?: IGetUserDetailResponse;
    updateUser: (userOverrideFields: Partial<IGetUserDetailResponse>) => void;
    isSwitchUser: boolean;
    update: (value: Unionize<Omit<Props, 'update'>>) => void;
    logout: () => void;
}

const state: StateCreator<Props> = (set) => ({
    user: undefined,

    //Helper method to update user specific fields
    updateUser: (userOverrideFields) =>
        set((state) => ({
            user:
                state.user && userOverrideFields && Object.keys(userOverrideFields).length > 0
                    ? {
                          ...state.user,
                          ...userOverrideFields,
                      }
                    : state.user,
        })),
    isSwitchUser: false,
    update: (value) => set({ ...value }),
    logout: () => {
        set(() => ({ user: undefined, isSwitchUser: false }));
        localStorage.removeItem('loginUser');
    },
});

export const useUserStore = create(persist(state, { name: 'loginUser' }));
